// Celular (≤ 767): barra de baixo do lab (shell-mobile.js, 25/10) — Módulos · Tickets · Alertas · Menu.
//  - Módulos: a própria barra lateral (.sidebar) sobe de baixo como gaveta.
//  - Tickets: vai para a tela de tickets (URL no data-m-tickets do <aside>); na tela, mostra o total do chip "Todos".
//  - Alertas: abre o painel de notificações que já existe no topo (.bt-notifications), por cima da barra.
//  - Menu: gaveta da conta — Meus dados, tema Dia/Noite, Online/Offline (se houver), Suporte e Sair, copiados do topo.
// Os botões do topo (tema, sino, suporte, usuário) saem da vista no celular (shell/_mobile.scss); o markup deles não muda.
// Nada aqui roda fora do celular: as peças são criadas uma vez e o CSS só as mostra ≤ 767.
const $ = window.jQuery;
const Theme = require('./Theme');

const MenuBaixo = function () {

    const MQ = window.matchMedia('(max-width: 767px)');
    const body = document.body;
    let colapsadoAntes = null;   // a gaveta mostra o menu inteiro; ao fechar, a barra volta como estava (desktop)

    const ico = (nome) => '<i class="ai ai-' + nome + ' ico-line" aria-hidden="true"></i><i class="ai ai-' + nome + '-solid ico-solid" aria-hidden="true"></i>';
    const aba = (m, icone, rot, extra) =>
        '<button class="m-aba" type="button" data-m="' + m + '"' + (extra || '') + '>' +
            '<span class="m-aba-ico">' + ico(icone) + '</span><span class="m-aba-rot">' + rot + '</span>' +
            (m === 'tickets' ? '<span class="m-aba-num" hidden></span>' : '') +
        '</button>';
    const topoGaveta = () =>
        '<div class="m-gaveta-topo"><span class="m-pega" aria-hidden="true"></span>' +
        '<button class="m-fechar" type="button" aria-label="Fechar"><i class="ai ai-x" aria-hidden="true"></i></button></div>';
    const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    const abre = (qual) => {
        if (qual === 'modulos' && body.dataset.collapsed === 'true') { colapsadoAntes = 'true'; body.dataset.collapsed = 'false'; }
        if (!qual && colapsadoAntes !== null) { body.dataset.collapsed = colapsadoAntes; colapsadoAntes = null; }
        if (qual) body.dataset.mGaveta = qual; else delete body.dataset.mGaveta;
        delete body.dataset.mBaixoRecolhida;
        document.querySelectorAll('.m-baixo [data-m="modulos"], .m-baixo [data-m="conta"]').forEach((b) => b.setAttribute('aria-expanded', b.dataset.m === qual ? 'true' : 'false'));
        inertes();
        marcaAtiva();
    };

    const inertes = () => {
        const m = MQ.matches, g = body.dataset.mGaveta;
        const sb = document.querySelector('.sidebar'), ct = document.querySelector('.m-conta');
        if (sb) sb.toggleAttribute('inert', m && g !== 'modulos');
        if (ct) ct.toggleAttribute('inert', m && g !== 'conta');
    };

    // O balão fica em UM botão: o da gaveta aberta; sem gaveta, Tickets na tela de tickets e Módulos em qualquer outra.
    const marcaAtiva = () => {
        const barra = document.querySelector('.m-baixo');
        if (barra) barra.dataset.ativa = body.dataset.mGaveta || (document.querySelector('.tk-tela') ? 'tickets' : 'modulos');
    };

    // Número de tickets (pílula verde): o total do chip "Todos" da fila, quando a tela de tickets está aberta.
    const numeroTickets = () => {
        const alvo = document.querySelector('.m-baixo .m-aba-num');
        const v = document.querySelector('#tk-fila .tk-chip[data-aba="todos"] .tk-chip-n:not([hidden]) .tk-chip-v');
        if (!alvo) return;
        const n = v ? v.textContent.trim() : '';
        alvo.textContent = n;
        alvo.hidden = !n || n === '0';
    };

    const monta = () => {
        if (document.querySelector('.m-baixo')) return;
        const sb = document.querySelector('.sidebar');
        if (!sb) return;

        const nome = ((document.querySelector('#o_user_menu .um-head b') || {}).textContent || '').trim();
        const meusDados = document.querySelector('#o_user_menu a.um-item:not([data-danger]):not([data-m-conta-item])');
        // Itens extras do dropdown que pedem par na gaveta (ex.: "Configurador", docs/configurador RD-01): só os marcados com
        // data-m-conta-item="<ícone>", na ordem do topo, logo depois de "Meus dados". Sem a marca, nada muda nesta gaveta.
        const extras = document.querySelectorAll('#o_user_menu a.um-item[data-m-conta-item]:not([data-danger])');
        const sair = document.querySelector('#o_user_menu a.um-item[data-danger]');
        const suporte = document.querySelector('.tb-actions .bt-header-trigger-suport-api');
        const online = document.querySelectorAll('#o_online_menu a.um-item');
        const temSino = !!document.querySelector('.tb-actions .bt-notifications');

        const barra = document.createElement('nav');
        barra.className = 'm-baixo';
        barra.setAttribute('aria-label', 'Navegação');
        barra.innerHTML =
            aba('modulos', 'table', 'Módulos', ' aria-expanded="false" aria-haspopup="dialog"') +
            aba('tickets', 'ticket', 'Tickets') +
            (temSino ? aba('alertas', 'bell', 'Alertas') : '') +
            aba('conta', 'person-circle', 'Menu', ' aria-expanded="false" aria-haspopup="dialog"');

        const veu = document.createElement('div');
        veu.className = 'm-veu';

        const item = (a, icone, rot, extra) => a
            ? '<a class="m-item" href="' + esc(a.getAttribute('href')) + '"' + (a.target ? ' target="' + esc(a.target) + '" rel="noopener"' : '') + (extra || '') + '>' +
              '<span class="m-item-ico"><i class="ai ai-' + icone + '" aria-hidden="true"></i></span><span class="m-item-rot">' + esc(rot) + '</span></a>'
            : '';
        const conta = document.createElement('div');
        conta.className = 'm-conta';
        conta.setAttribute('role', 'dialog');
        conta.setAttribute('aria-label', 'Menu da conta');
        conta.innerHTML =
            topoGaveta() +
            '<div class="m-conta-quem"><span class="m-conta-av">' + esc(nome.charAt(0).toUpperCase()) + '</span><div><b>' + esc(nome) + '</b></div></div>' +
            item(meusDados, 'person-square', meusDados ? meusDados.textContent.trim() : '') +
            Array.from(extras).map((a) => item(a, (a.dataset.mContaItem || '').replace(/[^a-z0-9-]/g, '') || 'circle', a.textContent.trim())).join('') +
            '<div class="m-item m-item-tema"><span class="m-item-ico"><i class="ai ai-sun" aria-hidden="true"></i></span><span class="m-item-rot">Tema</span>' +
                '<span class="m-tema" role="group" aria-label="Tema">' +
                    '<button type="button" data-m-tema="light"><i class="ai ai-sun" aria-hidden="true"></i>Dia</button>' +
                    '<button type="button" data-m-tema="dark"><i class="ai ai-crescent" aria-hidden="true"></i>Noite</button>' +
                '</span></div>' +
            (online.length ? '<div class="m-item m-item-online"><span class="m-item-ico"><i class="ai ai-person" aria-hidden="true"></i></span><span class="m-item-rot">Status</span><span class="m-tema" role="group" aria-label="Status">' +
                Array.from(online).map((a, i) => '<button type="button" data-m-online="' + i + '">' + esc(a.textContent.trim()) + '</button>').join('') + '</span></div>' : '') +
            item(suporte, 'headphones', 'Suporte') +
            item(sair, 'arrow-from-bracket-right', sair ? sair.textContent.trim() : '', ' data-danger="true"');

        document.body.append(veu, conta, barra);
        if (!sb.querySelector('.m-gaveta-topo')) sb.insertAdjacentHTML('afterbegin', topoGaveta());

        // Tela de tickets: a pílula acompanha o chip "Todos" (o FilaAbas troca o número por Pusher).
        const filtros = document.querySelector('#tk-fila .tk-filtros');
        if (filtros && window.MutationObserver) new MutationObserver(numeroTickets).observe(filtros, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
        numeroTickets();
        marcaTema();
        marcaAtiva();
        inertes();
    };

    const marcaTema = () => {
        const t = document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
        document.querySelectorAll('.m-conta [data-m-tema]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.mTema === t ? 'true' : 'false'));
    };

    const aoClicar = (e) => {
        if (!MQ.matches) return;
        const alvo = e.target instanceof Element ? e.target : null;
        if (!alvo) return;
        if (alvo.closest('.m-fechar') || alvo.closest('.m-veu')) { abre(null); return; }

        const b = alvo.closest('.m-baixo [data-m]');
        if (b) {
            const m = b.dataset.m;
            if (m === 'modulos' || m === 'conta') { abre(body.dataset.mGaveta === m ? null : m); return; }
            abre(null);
            if (m === 'tickets') {
                const url = (document.querySelector('.sidebar') || {}).dataset ? document.querySelector('.sidebar').dataset.mTickets : '';
                if (url && !document.querySelector('.tk-tela')) window.location.href = url;
                return;
            }
            if (m === 'alertas') {
                // O sino do topo continua sendo quem busca e abre o painel (Bootstrap); o CSS o põe acima da barra.
                e.stopPropagation();
                const sino = document.querySelector('.tb-actions .bt-notifications');
                if (sino && $) $(sino).trigger('click');
            }
            return;
        }

        if (body.dataset.mGaveta === 'modulos' && alvo.closest('.sidebar a.nav-item[href]')) { setTimeout(() => abre(null), 120); return; }

        const tema = alvo.closest('.m-conta [data-m-tema]');
        if (tema) { Theme.set(tema.dataset.mTema); marcaTema(); return; }

        const on = alvo.closest('.m-conta [data-m-online]');
        if (on) { const a = document.querySelectorAll('#o_online_menu a.um-item')[+on.dataset.mOnline]; if (a) a.click(); abre(null); return; }

        if (alvo.closest('.m-conta a.m-item')) abre(null);
    };

    // A barra se recolhe ao rolar uma lista para baixo e volta ao subir (lab, item 6). Folga de 8px contra tremida.
    const ultimo = new WeakMap();
    const aoRolar = (e) => {
        if (!MQ.matches) return;
        const el = e.target === document ? document.scrollingElement : e.target;
        if (!el || !el.closest) return;
        const naGaveta = el.closest('.sidebar, .m-conta');
        if (body.dataset.mGaveta ? !naGaveta : naGaveta) return;
        const y = el.scrollTop, antes = ultimo.has(el) ? ultimo.get(el) : 0;
        if (y <= antes && y >= el.scrollHeight - el.clientHeight - 2) return;   // quique do iPhone no fim da lista
        if (Math.abs(y - antes) < 8) return;
        ultimo.set(el, y);
        if (y > antes && y > 40) body.dataset.mBaixoRecolhida = ''; else delete body.dataset.mBaixoRecolhida;
    };

    return {
        init: function () {
            if (!document.querySelector('.sidebar')) return;
            monta();
            document.addEventListener('click', aoClicar, true);
            document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && body.dataset.mGaveta) abre(null); });
            document.addEventListener('scroll', aoRolar, true);
            const virou = () => { if (!MQ.matches) abre(null); inertes(); };
            if (MQ.addEventListener) MQ.addEventListener('change', virou); else if (MQ.addListener) MQ.addListener(virou);
        }
    };
}();

module.exports = MenuBaixo;
